/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Gender_Man2Inputs */

const nl_enums_gender_man2 = /** @type {(inputs: Enums_Gender_Man2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Man`)
};

/**

* @param {Enums_Gender_Man2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_gender_man2 = /** @type {((inputs?: Enums_Gender_Man2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Gender_Man2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_gender_man2(inputs)
});
export { enums_gender_man2 as "enums.Gender.Man" }